<template>
    <ConfirmDialog group="dialog" />
    <div class="p-grid">
        <!-- <div class="p-col-12 p-pb-0">
            <Button @click="$router.go(-1)" label="Go Back" icon="pi pi-angle-left" class="p-button-text p-mr-2 p-mb-2" />
        </div> -->
        <Toast/>
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('Survey.list.Survey Details')}}</strong>
                </h4>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Survey.list.Survey Title')}}:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.survey_title }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Survey.list.Survey URL')}}:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.survey_url }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Survey.list.Start Date & Time')}}:</label>
                    <div class="p-col-12 p-md-10">{{ formatDate(mydata.start_date) }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Survey.list.End Date & Time')}}:</label>
                    <div class="p-col-12 p-md-10">{{ formatDate(mydata.end_date) }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Survey.list.Registration Date & Time')}}:</label>
                    <div class="p-col-12 p-md-10">{{ formatDate(mydata.created_date) }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Survey.list.Survey Status')}}:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.status }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Survey.list.Number Of Responses')}}:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.number_of_responses }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="p-col-12">
        <div class="p-d-flex p-jc-between">
            <div>
                <router-link :to="'/edit-survey/' + $route.params.id"
                    ><Button label="help" class="p-button-outlined p-button-help p-mr-2 p-mb-2"><i class="pi pi-user-edit p-mr-2"></i> Edit</Button></router-link
                >
                <Button @click="del($route.params.id)" label="delete" class="p-button-outlined p-button-danger p-mr-2 p-mb-2"><i class="pi pi-trash p-mr-2"></i> delete</Button>
            </div>
            <div>
                <Button @click="$router.go(-1)" label="Go Back" class="p-button-outlined p-mr-2 p-mb-2" />
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import SurveyService from '../../service/API/SurveyService';
import formatDate from '../../mixin/mixinFunction';
// import {useRouter} from 'vue-router'
export default {
    mixins: [formatDate],
    data() {
        return {
            disInq: true,
            renderTxt: false,
            replied: false,
            replyText: '',
            replyStatus: 'answered',
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            mydata: {},
        };
    },
    created() {
        this.surveyService = new SurveyService();
    },
    methods: {
        reply() {
            if (this.replyText != '') {
                this.inquiryService.inquiryReply(this.$route.params.id, this.replyText, this.replyStatus).then((data) => {
                    this.$toast.add({ severity: 'info', summary: '확인.', detail: '성공적으로 등록되었습니다.', life: 3000 });
                    console.log(data);
                });
            } else {
                alert('replay text should not blanck');
            }
        },
        del() {
            let self=this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'delete', url: `/survey/ ` + this.$route.params.id}).then((res) => {
                        console.warn(res);
                        self.$toast.add({severity: 'error', summary: 'Delete Message', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                        setTimeout(() => {
                            self.$router.push({ name: 'surveyList' });
                        }, 1000);
                        
                    });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
    mounted() {
        this.surveyService.survyDetails(this.$route.params.id).then((data) => {
            console.log(data);
            this.mydata = data;
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}
.renderHtml {
    background-color: #fcfcfc;
    padding: 25px;
    border: 1px solid rgba(70, 77, 242, 0.2);
    border-radius: 5px;
    margin-top: 15px;
}
</style>
